import { isNativeApp } from '../../../selectors/app';
import { WithAppNamespace } from '../../../state/app';
import { WithSurveyNamespace } from '../../../state/survey';
import { hasOptionalQuestions } from './hasOptionalQuestions';

export const isOrderFormSplittedInTwoPages = <
    State extends WithSurveyNamespace & WithAppNamespace,
>(
    state: State,
): boolean => !isNativeApp(state) && hasOptionalQuestions(state);
